export interface UndoRedoControlsProps {
    canUndo: boolean;
    canRedo: boolean;
    onUndo: () => void;
    onRedo: () => void;
}

export function UndoRedoControls({
    canUndo,
    canRedo,
    onUndo,
    onRedo,
}: UndoRedoControlsProps) {
    return (
        <>
            <button
                type="button"
                className="generic-button"
                onClick={onUndo}
                disabled={!canUndo}
                title="Undo (Ctrl+Z)"
            >
                Undo
            </button>
            <button
                type="button"
                className="generic-button"
                onClick={onRedo}
                disabled={!canRedo}
                title="Redo (Ctrl+Y)"
            >
                Redo
            </button>
        </>
    );
}
